<div class="hoge">
</div>

<script>
import { HorizontalBar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins
export default {
  extends: HorizontalBar,
  mixins: [reactiveProp],
  name: 'Chart',
  components: {
  },
  data () {
    return {
    }
  },
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
    width: {
      type: Number,
      default: 600
    }
  },
  methods: {
  },
  mounted: function () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/main/js/components/sheet/Chart.vue